/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import SearchBar from '@/components/SearchBar';
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import { getHdProjectList } from '@/api';
export default {
  name: 'CheckProject',
  props: {
    showMask: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SearchBar: SearchBar,
    Popup: Popup,
    ViewBox: ViewBox,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem
  },
  computed: {
    isShow: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    },
    scrollerHight: function scrollerHight() {
      // eslint-disable-next-line
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 5.8 * fontSize;
    }
  },
  data: function data() {
    return {
      pageIndex: 0,
      pageSize: 10,
      searchForm: {},
      spareList: [],
      checkList: []
    };
  },
  created: function created() {
    this.loadList(true);
  },
  methods: {
    getItem: function getItem(e) {
      this.$emit('getItem', e);
    },
    loadList: function loadList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reset;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reset = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;

                if (reset) {
                  _this.pageIndex = 0;
                }

                getHdProjectList(_objectSpread({
                  pageIndex: _this.pageIndex,
                  pageSize: _this.pageSize
                }, _this.searchForm)).then(function (res) {
                  if (res.success) {
                    if (reset) {
                      _this.spareList = res.data;
                    } else {
                      _this.spareList = _this.spareList.concat(res.data);
                    }

                    _this.$refs['scrollerList'] && _this.$refs['scrollerList'].donePulldown();

                    if (res.data.length < _this.pageSize) {
                      _this.$refs['scrollerList'] && _this.$refs['scrollerList'].disablePullup();
                    }
                  } else {
                    _this.$vux.toast.text(res.message);
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onPullupLoading: function onPullupLoading() {
      this.pageIndex = this.pageIndex + 1;
      this.loadList();
    },
    onPulldownLoading: function onPulldownLoading() {
      this.spareList = [];
      this.$refs['scrollerList'] && this.$refs['scrollerList'].enablePullup();
      this.loadList(true);
    }
  }
};